import { useEffect } from 'react';

import { getContent } from '@/utils/helper';

const DOT_SIZE = '12.29';
const DOT_HOVER_SIZE = '15';

function CutsNavigationDD({
  backgroundSrc,
  cuts,
  entries,
  svgRef,
  handleCowNavigation,
}) {
  const cutsDetail = cuts.map((c) => getContent(c.sys.id, entries)?.fields);

  useEffect(() => {
    const ref = svgRef?.current;
    if (!ref) return;

    function updateDotPosition(el, action) {
      const dots = el.querySelectorAll('use');
      if (!dots?.length) return;

      dots.forEach((d) => {
        // update x y to keep it centered when the size changed
        const coordinates =
          d
            ?.getAttribute('transform')
            ?.replace(/[a-z() ]/gi, '')
            ?.split(',') ?? [];
        const [y0, x0] = coordinates;
        const deltaX = 1.5;
        const deltaY = 1;
        const x1 = action === 'reset' ? +x0 + deltaX : +x0 - deltaX;
        const y1 = action === 'reset' ? +y0 + deltaY : +y0 - deltaY;
        d.setAttribute('transform', `translate(${y1}, ${x1})`);
      });
    }

    function resetDotSizeOverlay() {
      // reset dot size
      const dots = ref.querySelectorAll('.dot');
      dots.forEach((d) => {
        d.setAttribute('width', DOT_SIZE);
        d.setAttribute('height', DOT_SIZE);
      });
      // remove overlay dot
      const overlays = ref.querySelectorAll('.overlay');
      overlays.forEach((o) => {
        if (!o?.classList?.contains('opacity-0')) {
          o.classList.add('opacity-0');
        }
        o.classList.remove('opacity-10');
      });
    }

    const addDotOverlay = (el) => {
      const dot = el.querySelector('.dot');
      dot.setAttribute('width', DOT_HOVER_SIZE);
      dot.setAttribute('height', DOT_HOVER_SIZE);

      const overlay = el.querySelector('.overlay');
      overlay.classList.remove('opacity-0');
      overlay.classList.add('opacity-10');
    };

    ref.querySelectorAll('#outlines > g').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        resetDotSizeOverlay();
        addDotOverlay(el);
        updateDotPosition(el, 'update');
      });
      el.addEventListener('mouseout', function () {
        resetDotSizeOverlay();
        updateDotPosition(el, 'reset');
      });
    });
  }, [svgRef]);
  return (
    <svg
      ref={svgRef}
      className="cuts-outline w-[95%] md:w-full lg:w-auto h-fit md:h-[92%] md:absolute md:top-[6%]"
      viewBox="0 0 738.71 456.77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0" width="738.71" height="456.77" fill="url(#pattern0)" />
      <g id="cow">
        {/* START: cow outlines */}
        <g id="outlines">
          <g data-slug={cutsDetail?.[0]?.slug}>
            <a
              href={`#${cutsDetail?.[0]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[0]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(201.11,90.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(201.11,90.58)"
              ></use>
              <text
                id="text-1"
                fill="white"
                transform="translate(185.71,120.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[0]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[1]?.slug}>
            <a
              href={`#${cutsDetail?.[1]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[1]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(216.11,49.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(216.11,49.58)"
              ></use>

              <text
                id="text-2"
                fill="white"
                transform="translate(196.11,79.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[1]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[2]?.slug}>
            <a
              href={`#${cutsDetail?.[2]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[2]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(638.11,117.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(638.11,117.58)"
              ></use>
              <text
                id="text-3"
                fill="white"
                transform="translate(620.11,147.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[2]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[3]?.slug}>
            <a
              href={`#${cutsDetail?.[3]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[3]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(259.11,195.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(259.11,195.58)"
              ></use>
              <text
                id="text-4"
                fill="white"
                transform="translate(224.11,225.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[3]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[4]?.slug}>
            <a
              href={`#${cutsDetail?.[4]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[4]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(339.11,118.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(339.11,118.58)"
              ></use>

              <text
                id="text-5"
                fill="white"
                transform="translate(324.11,148.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[4]?.title}
              </text>
            </a>
          </g>

          <g data-slug={cutsDetail?.[5]?.slug}>
            <a
              href={`#${cutsDetail?.[5]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[5]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(618.11,76.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(618.11,76.58)"
              ></use>
              <text
                id="text-6"
                fill="white"
                transform="translate(608.11,106.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[5]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[6]?.slug}>
            <a
              href={`#${cutsDetail?.[6]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[6]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(247.5,155.9)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(247.5,155.9)"
              ></use>
              <text
                id="text-7"
                fill="white"
                transform="translate(207.5,185.9)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[6]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[7]?.slug}>
            <a
              href={`#${cutsDetail?.[7]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[7]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(257.11,241.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(257.11,241.58)"
              ></use>

              <text
                id="text-8"
                fill="white"
                transform="translate(245.11,271.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[7]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[8]?.slug}>
            <a
              href={`#${cutsDetail?.[8]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[8]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(433.11,202.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(433.11,202.58)"
              ></use>
              <text
                id="text-9"
                fill="white"
                transform="translate(423.11,232.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[8]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[9]?.slug}>
            <a
              href={`#${cutsDetail?.[9]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[9]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(472.11,241.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(472.11,241.58)"
              ></use>
              <text
                id="text-10"
                fill="white"
                transform="translate(452.11,271.41)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[9]?.title}
              </text>
            </a>
          </g>
          <g data-slug={cutsDetail?.[10]?.slug}>
            <a
              href={`#${cutsDetail?.[10]?.slug}`}
              onClick={(e) => handleCowNavigation(e, cutsDetail?.[10]?.title)}
            >
              <use
                href="#circle-dot"
                className="dot"
                transform="translate(634.11,172.58)"
              ></use>
              <use
                href="#circle-overlay"
                className="overlay opacity-0 transition-all"
                transform="translate(634.11,172.58)"
              ></use>
              <text
                id="text-10"
                fill="white"
                transform="translate(620.11,202.58)"
                className="font-text font-body-bold text-body-bold"
              >
                {cutsDetail?.[10]?.title}
              </text>
            </a>
          </g>
        </g>
        {/* END: cow outlines */}
      </g>
      <defs>
        {/* START: circle-dot icon */}
        <svg
          id="circle-overlay"
          viewBox="0 0 13 13"
          width={DOT_HOVER_SIZE}
          height={DOT_HOVER_SIZE}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6.61806" cy="6.53895" r="6.14491" fill="#252525" />
        </svg>
        <svg
          id="circle-dot"
          width={DOT_SIZE}
          height={DOT_SIZE}
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6.61806" cy="6.53895" r="6.14491" fill="#B09471" />
        </svg>
        {/* END: circle-dot icon */}
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_2819_129713"
            transform="translate(-0.00472666) scale(0.000625824 0.0010101)"
          />
        </pattern>
        <image
          id="image0_2819_129713"
          width="1613"
          height="990"
          href={`${backgroundSrc}?fm=webp&q=80&w=800`}
        />
      </defs>
    </svg>
  );
}

export default CutsNavigationDD;
